export const EDIT_DRAFT_TEXT_STRATEGY = {
  FROM_MASTER: 'fromMaster',
  FROM_LIVE: 'fromLive',
};

export const EDIT_DRAFT_TEXT_CANCEL = 'cancel';
